import { Component, OnInit } from '@angular/core';
import {UtilService} from '../../services/utilService/util.service';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {SuperAdminService} from '../../services/apiCalls/superAdminService/super-admin.service';
import {UserService} from '../../services/apiCalls/userService/user.service';
import { environment as ENV } from '../../../environments/environment';
import {IResponse} from '../../interfaces/iresponse';

@Component({
  selector: 'app-commission-share',
  templateUrl: './commission-share.component.html',
  styleUrls: ['./commission-share.component.css']
})
export class CommissionShareComponent implements OnInit {
  breadCrumb: any;
  showData = true;
  public sharingFormulas: any[] = [];
  loadingData = false;
  loaders = {
    saving: false
  };
  constructor(private utilService: UtilService,
              private bootstrapNotify: BootstrapNotifyService,
              private userService: UserService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'My Commissions',
      parent: 'Home',
      subLink: null
    };
    this.getSharingFormulas();
  }

  getSharingFormulas() {
    this.showData = false;
    this.loadingData = true;
    this.userService.getSharingFormulas()
      .subscribe((res: IResponse) => {
        this.sharingFormulas = res.data;
        this.utilService.riderTable('all-sharing-formula', false);
        this.loadingData = false;
        this.showData = true;
      }, error => {
        console.log('Error ', error);
        this.utilService.startDatatable('all-sharing-formula');
        this.loadingData = false;
        this.showData = true;
      });
  }


}
